import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DropdownDirective } from '../components/dropdown.directive';
import { ModalsModule } from '../modals/modals.module';
import { NotificationComponent } from '../notifier/notification.component';
import { UserModule } from '../user/user.module';
import { HeaderMenuComponent } from './header-menu.component';
import { HeaderComponent } from './header.component';
import { HeaderService } from './header.service';
import { AboutEntry } from './setting-entries/about-entry';
import { BillingEntry } from './setting-entries/billing-entry';
import { EulaEntry } from './setting-entries/eula-entry';
import { HelpEntry } from './setting-entries/help-entry';
import { SupportEntry } from './setting-entries/support-entry';
import { HelpPdfEntry } from './setting-entries/help-pdf-entry';
import { ApiHelpEntry } from './setting-entries/api-help-entry';
import { ApiHelpPdfEntry } from './setting-entries/api-help-pdf-entry';
import { LogOutEntry } from './setting-entries/logout-entry';
import { TargetValidationEntry } from './setting-entries/target-validation-entry';
import { TOSEntry } from './setting-entries/tos-entry';
import { PythonApiEntry } from './setting-entries/python-api-entry';

@NgModule({
    imports: [CommonModule, FormsModule, UserModule, ModalsModule],
    declarations: [HeaderComponent, HeaderMenuComponent, NotificationComponent, DropdownDirective],
    providers: [
        { provide: 'SettingsEntry', useClass: TargetValidationEntry, multi: true },
        { provide: 'SettingsEntry', useClass: TOSEntry, multi: true },
        //{ provide: 'SettingsEntry', useClass: EulaEntry, multi: true },
        { provide: 'SettingsEntry', useClass: BillingEntry, multi: true },
        { provide: 'SettingsEntry', useClass: HelpEntry, multi: true },
        { provide: 'SettingsEntry', useClass: HelpPdfEntry, multi: true },
        { provide: 'SettingsEntry', useClass: ApiHelpEntry, multi: true },
        { provide: 'SettingsEntry', useClass: ApiHelpPdfEntry, multi: true },
        { provide: 'SettingsEntry', useClass: PythonApiEntry, multi: true },
        { provide: 'SettingsEntry', useClass: SupportEntry, multi: true },
        { provide: 'SettingsEntry', useClass: AboutEntry, multi: true },
        { provide: 'SettingsEntry', useClass: LogOutEntry, multi: true },
        HeaderService
    ],

    exports: [
        HeaderComponent,
        HeaderMenuComponent,
        DropdownDirective
    ],

})
export class HeaderFooterModule { }



// WEBPACK FOOTER //
// ./src/app/headerfooter/headerfooter.module.ts